// extracted by mini-css-extract-plugin
module.exports = {"fieldLabelFormater":"TextWrapper_fieldLabelFormater__WBk6q","description":"TextWrapper_description__9WF8C","lastWords":"TextWrapper_lastWords__BYWk_"};